import { CREATEOBJECTIVE_SUCCESS, CREATEOBJECTIVE_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const createObjectiveOKRReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATEOBJECTIVE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case CREATEOBJECTIVE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createObjectiveOKRReducer;



